var React = require('react');

function CalendarRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 0.707)"},[React.createElement("path",{"d":"M7.5,18h21","transform":"translate(-7.5 -7.5)","fill":"none","stroke":"#000","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M18,7.5,28.5,18,18,28.5","transform":"translate(-7.5 -7.5)","fill":"none","stroke":"#000","strokeWidth":"2","key":1})]));
}

CalendarRight.defaultProps = {"width":"22.414","height":"22.414","viewBox":"0 0 22.414 22.414"};

module.exports = CalendarRight;

CalendarRight.default = CalendarRight;
